/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{getAssetUrl as e}from"../../assets.js";function t(){if(null==s){const t=t=>e(`esri/libs/basisu/${t}`);s=import("../../chunks/basis_transcoder.js").then((e=>e.b)).then((({default:e})=>e({locateFile:t}).then((e=>(e.initializeBasis(),delete e.then,e)))))}return s}let s;export{t as getBasisTranscoder};
